(function () {
  'use strict';

  // ---- SHARED Waterly buy-box bundle engine (product-agnostic) ----
  // Reads product.variants from the DOM (the section's swatch rows), builds
  // /cart/add.js items for bundle "1" (single) vs "2+1" (triple), and refreshes
  // + opens the Shrine cart-drawer via renderContents(state, false). The Meta
  // pixel rides on the standard /cart/add.js request. One root selector
  // ([data-wt-buybox]) serves BOTH the kids and adult buy boxes — the only
  // per-product differences (copy, prices, fallback swatch images) live in the
  // .liquid markup, not here.

  // ---- Shrine cart drawer integration (grounded in assets/main.js: CartDrawer open/close + renderContents) ----

  // Fade image swap (design: opacity 0 -> 150ms -> src swap -> opacity 1; CSS transition .22s)
  function fadeSwap(img, src) {
    if (!img || !src) return;
    if (img.src === src) return;
    img.style.opacity = '0';
    setTimeout(function () { img.src = src; img.style.opacity = '1'; }, 150);
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  // OPEN the Shrine cart drawer. Mirrors CartDrawer.open(triggerEl).
  function openShrineCartDrawer(trigger) {
    var drawer = getDrawer();
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open(trigger || document.activeElement || undefined);
    } else {
      setTimeout(function () { drawer.classList.add('animate', 'active'); });
      document.body.classList.add('overflow-hidden');
    }
  }

  // Manual Section-Rendering swap (fallback if renderContents is unavailable).
  function shrineSwapDrawerHTML(state) {
    var html = state.sections && state.sections['cart-drawer'];
    if (html) {
      var rendered = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      var target = document.getElementById('CartDrawer');
      if (rendered && target) target.innerHTML = rendered.innerHTML;
    }
    var bubbleHtml = state.sections && state.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var rb = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
        if (rb) bubble.innerHTML = rb.innerHTML;
      }
    }
  }

  // POST to /cart/add.js WITH sections, then refresh + open the Shrine drawer.
  // addBody is either {id, quantity} (single) or {items:[...]} (bundle).
  function shrineAddToCartAndRefresh(addBody, trigger) {
    var drawer = getDrawer();
    var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    return fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.assign({}, addBody, {
        sections: sections,
        sections_url: window.location.pathname
      }))
    }).then(function (res) {
      // Treat any non-2xx as an error. On 5xx / HTML error pages / aborted
      // requests res.json() rejects (handled by handleAdd's .catch). For non-2xx
      // bodies that still parse (e.g. some proxy shapes), force a status field so
      // the success branch never runs against an error response.
      if (!res.ok) {
        return res.json().catch(function () {
          return { status: res.status, message: 'HTTP ' + res.status };
        }).then(function (body) {
          if (body && typeof body === 'object' && !body.status) body.status = res.status;
          return body;
        });
      }
      return res.json();
    }).then(function (state) {
      if (state.status) {
        // 422 etc. -> {status, message, description}
        console.error('cart/add error', state);
        return state;
      }

      // Open the Shrine cart drawer WITHOUT Shrine's open()/renderContents. Shrine's open() runs
      // trapFocus() on a focus container that is momentarily null during the empty->first-add
      // transition (getFocusableElements(null) -> crash -> blank/white drawer; env/timing dependent).
      // We sidestep the entire crash surface: swap the content ourselves (correct #CartDrawer id),
      // drop the stale is-empty class, and toggle the .active classes by hand (pure-CSS open, no JS
      // focus trap). Structurally crash-proof regardless of environment/network timing.
      shrineSwapDrawerHTML(state);
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(trigger || document.activeElement);
        }
        drawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
        // We bypassed open(), so wire close() onto the freshly-swapped overlay + close button.
        var ov = document.getElementById('CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', function () { if (typeof drawer.close === 'function') drawer.close(); });
        var xb = drawer.querySelector('.drawer__close');
        if (xb) xb.addEventListener('click', function () { if (typeof drawer.close === 'function') drawer.close(); });
      }
      return state;
    });
  }

  function init(root) {
    if (!root || root.dataset.wtBuyboxInit) return;
    root.dataset.wtBuyboxInit = '1';

    var sid = root.getAttribute('data-section-id');
    var qsa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var main = document.getElementById('wt-main-' + sid);

    var config = {};
    try { config = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) { config = {}; }

    var single = root.querySelector('[data-wt-single]');
    var triple = root.querySelector('[data-wt-triple]');
    var priceNow = root.querySelector('[data-wt-price-now]');
    var priceCmp = root.querySelector('[data-wt-price-cmp]');

    var ctaButtons = function () {
      // CTA inside this section + any sticky bar on the page (shares data-add).
      return Array.prototype.slice.call(document.querySelectorAll('[data-wt-add]'));
    };

    var state = { bundle: '1' };

    // ---- Thumbnails ----
    qsa('[data-wt-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = t.getAttribute('data-image');
        if (main && img) fadeSwap(main, img);
        qsa('[data-wt-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // ---- Gallery prev/next arrows (step through the thumbnail images) ----
    var thumbEls = qsa('[data-wt-thumb]');
    function galleryStep(dir) {
      if (!main || !thumbEls.length) return;
      var idx = 0;
      for (var i = 0; i < thumbEls.length; i++) {
        if (thumbEls[i].classList.contains('is-active')) { idx = i; break; }
      }
      idx = (idx + dir + thumbEls.length) % thumbEls.length;
      var t = thumbEls[idx];
      var img = t.getAttribute('data-image');
      if (img && main) fadeSwap(main, img);
      thumbEls.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    }
    var prevBtn = root.querySelector('[data-wt-prev]');
    var nextBtn = root.querySelector('[data-wt-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { galleryStep(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { galleryStep(1); });

    // ---- Swatch rows (per-row active selection) ----
    qsa('[data-wt-row]').forEach(function (row) {
      var nameEl = row.querySelector('[data-wt-rowname]');
      row.querySelectorAll('[data-wt-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          var name = sw.getAttribute('data-name');
          var img = sw.getAttribute('data-image');
          if (nameEl && name) nameEl.textContent = name;
          if (main && img) fadeSwap(main, img);
          row.querySelectorAll('[data-wt-swatch]').forEach(function (x) { x.classList.remove('is-active'); });
          sw.classList.add('is-active');
        });
      });
    });

    // ---- Size toggle (1L / 600ml) per row: swap swatch group, keep exactly one is-active ----
    qsa('[data-wt-row]').forEach(function (row) {
      var nameEl = row.querySelector('[data-wt-rowname]');
      row.querySelectorAll('[data-wt-size-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.getAttribute('data-wt-size-btn');
          if (row.getAttribute('data-wt-size') === group) return;
          row.setAttribute('data-wt-size', group);
          row.querySelectorAll('[data-wt-size-btn]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          row.querySelectorAll('[data-wt-swatch]').forEach(function (x) { x.classList.remove('is-active'); });
          var first = row.querySelector('[data-wt-swatch][data-wt-sgroup="' + group + '"]');
          if (first) {
            first.classList.add('is-active');
            var name = first.getAttribute('data-name');
            var img = first.getAttribute('data-image');
            if (nameEl && name) nameEl.textContent = name;
            if (main && img) fadeSwap(main, img);
          }
        });
      });
    });

    // ---- Bundle selector ----
    function setBundle(q) {
      state.bundle = String(q);
      var isTriple = state.bundle === '3';
      if (single) single.hidden = isTriple;
      if (triple) triple.hidden = !isTriple;

      var ctaLabel = isTriple ? (config.cta_triple || '') : (config.cta_single || '');
      ctaButtons().forEach(function (btn) {
        if (btn.getAttribute('data-wt-sticky-cta') !== null) return; // sticky uses its own short label
        if (ctaLabel) {
          btn.textContent = ctaLabel;
          btn.setAttribute('data-default-label', ctaLabel);
        }
      });

      // Main price stays the per-bottle price ("7.490 Ft / kulacs") regardless of bundle —
      // the 2+1 total is shown on the bundle card and the CTA button.

      qsa('[data-wt-bundle]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-wt-bundle') === state.bundle);
      });
    }
    qsa('[data-wt-bundle]').forEach(function (b) {
      b.addEventListener('click', function () { setBundle(b.getAttribute('data-wt-bundle')); });
    });

    // ---- Build line items from the active swatch of each VISIBLE row ----
    function buildItems() {
      var visibleSet = state.bundle === '3' ? triple : single;
      if (!visibleSet) return [];
      var rows = Array.prototype.slice.call(visibleSet.querySelectorAll('[data-wt-row]'));
      var items = [];
      rows.forEach(function (row) {
        var active = row.querySelector('[data-wt-swatch].is-active') || row.querySelector('[data-wt-swatch]');
        if (!active) return;
        var id = active.getAttribute('data-variant-id');
        if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      return items;
    }

    // ---- Add to cart (shared by buy box CTA + sticky bar) ----
    function handleAdd(btn) {
      if (btn.dataset.wtBusy) return;
      var items = buildItems();
      if (!items.length) return;

      var original = btn.getAttribute('data-default-label') || btn.textContent;
      btn.dataset.wtBusy = '1';
      btn.textContent = config.adding_label || original;

      // Bundle 1 => single {id, quantity}; Bundle 2+1 => {items:[...]}.
      var addBody = items.length === 1 ? items[0] : { items: items };

      shrineAddToCartAndRefresh(addBody, btn).then(function (resp) {
        delete btn.dataset.wtBusy;
        if (resp && resp.status) {
          btn.textContent = original; // restore on error, don't break
          return;
        }
        btn.textContent = config.added_label || original;
        setTimeout(function () {
          if (!btn.dataset.wtBusy) btn.textContent = btn.getAttribute('data-default-label') || original;
        }, 1800);
      }).catch(function (err) {
        console.error('cart add failed', err);
        delete btn.dataset.wtBusy;
        btn.textContent = original;
      });
    }

    // Bind every [data-wt-add] (buy box + sticky share the handler).
    // On shopify:section:load the theme editor re-renders the section and init()
    // runs again, building a fresh closure (new state / single / triple refs).
    // Re-point each button at the CURRENT closure by removing the old listener and
    // attaching a new one. We stash the bound handler on the element so the old
    // listener can be removed precisely, avoiding stale-closure add-to-cart.
    document.querySelectorAll('[data-wt-add]').forEach(function (btn) {
      if (btn._wtAddHandler) {
        btn.removeEventListener('click', btn._wtAddHandler);
      }
      var handler = function (e) {
        e.preventDefault();
        handleAdd(btn);
      };
      btn._wtAddHandler = handler;
      btn.addEventListener('click', handler);
    });

    // Initial bundle (design default = 2+1 / "3" unless config overrides).
    setBundle(config.default_bundle === '1' ? '1' : '3');
  }

  function boot() {
    document.querySelectorAll('[data-wt-buybox]').forEach(init);
  }

  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-wt-buybox]');
    if (r) { r.removeAttribute('data-wt-buybox-init'); init(r); }
  });
})();
